module.exports = __webpack_public_path__ + "img/collabrate.27ee2459.png";